import {AgmCoreModule} from '@agm/core';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {fab, faFacebookSquare} from '@fortawesome/free-brands-svg-icons';
import {faFacebook} from '@fortawesome/free-brands-svg-icons/faFacebook';
import {faInstagram} from '@fortawesome/free-brands-svg-icons/faInstagram';
import {faLinkedin} from '@fortawesome/free-brands-svg-icons/faLinkedin';
import {faTwitterSquare} from '@fortawesome/free-brands-svg-icons/faTwitterSquare';
import {fad} from '@fortawesome/pro-duotone-svg-icons';
import {fal, faPlusCircle} from '@fortawesome/pro-light-svg-icons';
import {far} from '@fortawesome/pro-regular-svg-icons';
import {faEdit, fas} from "@fortawesome/pro-solid-svg-icons";
import {faAngleLeft} from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import {faAngleRight} from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import {faArrowCircleRight} from '@fortawesome/pro-solid-svg-icons/faArrowCircleRight';
import {faArrowLeft} from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import {faCalendarAlt} from '@fortawesome/pro-solid-svg-icons/faCalendarAlt';
import {faCalendarCheck} from '@fortawesome/pro-solid-svg-icons/faCalendarCheck';
import {faCamera} from '@fortawesome/pro-solid-svg-icons/faCamera';
import {faCar} from '@fortawesome/pro-solid-svg-icons/faCar';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import {faCaretRight} from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import {faCarMechanic} from '@fortawesome/pro-solid-svg-icons/faCarMechanic';
import {faCartPlus} from '@fortawesome/pro-solid-svg-icons/faCartPlus';
import {faCheck} from '@fortawesome/pro-solid-svg-icons/faCheck';
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import {faChevronLeft} from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import {faChevronRight} from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import {faClipboardList} from '@fortawesome/pro-solid-svg-icons/faClipboardList';
import {faClone} from '@fortawesome/pro-solid-svg-icons/faClone';
import {faCloudDownloadAlt} from '@fortawesome/pro-solid-svg-icons/faCloudDownloadAlt';
import {faCommentLines} from '@fortawesome/pro-solid-svg-icons/faCommentLines';
import {faCreditCard} from '@fortawesome/pro-solid-svg-icons/faCreditCard';
import {faDollarSign} from '@fortawesome/pro-solid-svg-icons/faDollarSign';
import {faEnvelope} from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import {faExclamationCircle} from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import {faFileInvoiceDollar} from '@fortawesome/pro-solid-svg-icons/faFileInvoiceDollar';
import {faFilePdf} from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import {faGreaterThanEqual} from '@fortawesome/pro-solid-svg-icons/faGreaterThanEqual';
import {faHome} from '@fortawesome/pro-solid-svg-icons/faHome';
import {faKey} from '@fortawesome/pro-solid-svg-icons/faKey';
import {faLocationArrow} from '@fortawesome/pro-solid-svg-icons/faLocationArrow';
import {faMapMarkerAlt} from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt';
import {faMapMarkerPlus} from '@fortawesome/pro-solid-svg-icons/faMapMarkerPlus';
import {faMoneyBillWave} from '@fortawesome/pro-solid-svg-icons/faMoneyBillWave';
import {faPencil} from '@fortawesome/pro-solid-svg-icons/faPencil';
import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone';
import {faPlus} from '@fortawesome/pro-solid-svg-icons/faPlus';
import {faPrint} from '@fortawesome/pro-solid-svg-icons/faPrint';
import {faQuestionCircle} from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import {faReceipt} from '@fortawesome/pro-solid-svg-icons/faReceipt';
import {faSearch} from '@fortawesome/pro-solid-svg-icons/faSearch';
import {faShoppingCart} from '@fortawesome/pro-solid-svg-icons/faShoppingCart';
import {faSort} from '@fortawesome/pro-solid-svg-icons/faSort';
import {faSquare} from '@fortawesome/pro-solid-svg-icons/faSquare';
import {faThumbsUp} from '@fortawesome/pro-solid-svg-icons/faThumbsUp';
import {faTimes} from '@fortawesome/pro-solid-svg-icons/faTimes';
import {faTimesCircle} from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import {faTrashAlt} from '@fortawesome/pro-solid-svg-icons/faTrashAlt';
import {faUser} from '@fortawesome/pro-solid-svg-icons/faUser';
import {faUserCircle} from '@fortawesome/pro-solid-svg-icons/faUserCircle';
import {faUserHardHat} from '@fortawesome/pro-solid-svg-icons/faUserHardHat';
import {faUserPlus} from '@fortawesome/pro-solid-svg-icons/faUserPlus';
import {faUsersCrown} from '@fortawesome/pro-solid-svg-icons/faUsersCrown';
import {faWarehouse} from '@fortawesome/pro-solid-svg-icons/faWarehouse';
import {faUserHelmetSafety} from "@fortawesome/pro-duotone-svg-icons";
import {MetaModule} from '@ngx-meta/core';
import {Angulartics2Module} from 'angulartics2';
import {FleetHeaderComponent} from '../app/shared/_components/_header-nav/fleet-header/fleet-header.component';
import {environment} from '../environments/environment';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {CancelFeeComponent} from './cancel-fee/cancel-fee.component';
import {CoreModule} from './core/core.module';
import {DynamicComponent} from './dynamic/dynamic.component';
import {LoginasComponent} from './loginas/loginas.component';
import {NotfoundComponent} from "./notfound/notfound.component";
import {SharedModule} from "./shared/shared.module";
import {SiteMaintenanceComponent} from './site-maintenance/site-maintenance.component';
import {UnsubscribeComponent} from './unsubscribe/unsubscribe.component';
import {ZipcheckComponent} from './zipcheck/zipcheck.component';
import {NgxIntlTelInputModule} from 'ngx-intl-tel-input';
import {AmplifyAuthenticatorModule} from '@aws-amplify/ui-angular';
import {API_KEYS} from './core/constants';
import {YmRedirectComponent} from './ym-redirect/ym-redirect.component';
import {MatCardModule} from "@angular/material/card";
import {MatMenuModule} from '@angular/material/menu';
import {YMGuard} from "./core/_guards/ym.guard";
import {MatDividerModule} from "@angular/material/divider";
import {MatListModule} from "@angular/material/list";
import {MatSidenavModule} from "@angular/material/sidenav";
import {FullPageSpinnerComponent} from "./full-page-spinner/full-page-spinner.component";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatIconModule} from "@angular/material/icon";

@NgModule({
    declarations: [
        AppComponent,
        DynamicComponent,
        CancelFeeComponent,
        UnsubscribeComponent,
        CancelFeeComponent,
        NotfoundComponent,
        LoginasComponent,
        SiteMaintenanceComponent,
        ZipcheckComponent,
        FleetHeaderComponent,
        YmRedirectComponent,
    ],
    imports: [
        AgmCoreModule.forRoot({
            apiKey: API_KEYS.GOOGLE_MAPS,
            libraries: ["places"]
        }),
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,   // forRoot needed based on this http://blog.angular-university.io/angular2-ngmodule/
        CoreModule.forRoot(),   // forRoot needed based on this http://blog.angular-university.io/angular2-ngmodule/
        AppRoutingModule,
        Angulartics2Module.forRoot({developerMode: !environment.angulartics}),
        MetaModule.forRoot(),
        BrowserAnimationsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatTabsModule,
        MatButtonModule,
        FontAwesomeModule,
        NgxIntlTelInputModule,
        AmplifyAuthenticatorModule,
        MatCardModule,
        MatMenuModule,
        MatDividerModule,
        MatListModule,
        MatSidenavModule,
        FullPageSpinnerComponent,
        MatToolbarModule,
        MatIconModule,
    ],
    exports: [
        AppComponent,
        CoreModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatTabsModule,
        MatButtonModule
    ],
    bootstrap: [AppComponent],
    providers: [
        // {provide: HTTP_INTERCEPTORS, useClass: SiteMaintenanceInterceptorService, multi: true},
        YMGuard
    ]

})

export class AppModule {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(fas);
        library.addIconPacks(far);
        library.addIconPacks(fab);
        library.addIconPacks(fal);
        library.addIconPacks(fad);
        library.addIcons(faEdit, faPencil, faSearch, faPlus, faTimes, faSort, faTimesCircle, faTrashAlt, faCaretDown, faCaretRight, faSquare,
            faCheck, faCheckCircle, faAngleRight, faAngleLeft, faChevronRight, faChevronLeft, faExclamationCircle, faArrowCircleRight,
            faShoppingCart, faCartPlus, faUser, faUsersCrown, faUserCircle, faUserPlus, faKey, faPrint, faCreditCard, faCamera, faCarMechanic, faCar,
            faCalendarCheck, faCalendarAlt, faEnvelope, faPhone, faCloudDownloadAlt, faDollarSign, faClone, faCommentLines,
            faWarehouse, faUserHardHat, faThumbsUp, faLocationArrow, faMapMarkerPlus, faMapMarkerAlt, faHome, faArrowLeft, faGreaterThanEqual,
            faClipboardList, faFileInvoiceDollar, faFilePdf, faMoneyBillWave, faQuestionCircle, faFacebookSquare, faFacebook, faLinkedin,
            faInstagram, faTwitterSquare, faReceipt, faPlusCircle, faUserHelmetSafety);
    }
}
